module.exports = __webpack_public_path__ + "static/media/source of knowledge-01-01.e0662cfa.svg";